<template>
  <div class="newton-rings-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>r_k = √(k·R·λ)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Side View Explanation (Simple) -->
          <g transform="translate(40, 40)">
             <rect x="0" y="0" width="80" height="5" fill="#888" /> <!-- Glass Plate -->
             <path d="M 0,-40 A 100,50 0 0 1 80,-40" fill="none" stroke="#888" transform="translate(0, 40)" /> <!-- Lens -->
             <text x="0" y="55" fill="#888" font-size="8">侧视图: 透镜+平板</text>
          </g>

          <!-- The Rings Pattern (Top View) -->
          <g transform="translate(240, 120)">
             <circle v-for="k in 8" :key="k" r="0" fill="none" :stroke="currentColor" stroke-width="2" :opacity="1 - (k/10)">
                <animate attributeName="r" :from="0" :to="Math.sqrt(k * radiusFactor * (wavelength/500)) * 20" dur="0.5s" fill="freeze" />
             </circle>
             <circle r="4" fill="#000" /> <!-- Central Dark Spot -->
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>曲率半径 R 越大，环越稀疏</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>波长 λ (显色)</label>
             <el-slider v-model="wavelength" :min="400" :max="700" size="mini"></el-slider>
          </div>
          <div class="row">
             <label>透镜曲率 R (放大倍率)</label>
             <el-slider v-model="radiusFactor" :min="1" :max="10" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>牛顿环是典型的**等厚干涉**现象。当平凸透镜放在平板玻璃上时，其间形成的空气薄膜厚度从接触点向四周均匀增加。光在上下两个表面反射后形成相干叠加。由于中心点等效厚度为零（计入半波损失后），中心呈现**暗点**，四周则为明暗相间的同心圆环。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewtonRingsViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      wavelength: 600,
      radiusFactor: 5
    }
  },
  computed: {
    currentColor() {
       if (this.wavelength > 620) return "#ff4757";
       if (this.wavelength > 500) return "#2ed573";
       return "#00d2ff";
    }
  }
}
</script>

<style scoped lang="scss">
.newton-rings-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05) ; padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
